"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class ListingContext
 * @description aggregates list scope in state and gives a context provider to share it
 */
var React = require("react");
var usePrevious_1 = require("../internalUtils/usePrevious");
var shallowEqual_1 = require("../internalUtils/shallowEqual");
exports.ListingContext = React.createContext({});
exports.ListingContextConsumer = exports.ListingContext.Consumer;
var defaultPageSize = 20;
var ListingContextProvider = function (_a) {
    var pagingOptions = _a.paging, _b = _a.sorting, sortingOptions = _b === void 0 ? {} : _b, children = _a.children;
    var _c = __read(React.useState(0), 2), pageNumber = _c[0], setPageNumber = _c[1];
    var _d = __read(React.useState(sortingOptions.initialSortOrder), 2), sortOrder = _d[0], rawSetSortOrder = _d[1];
    var _e = __read(React.useState({}), 2), filterValues = _e[0], setFilterValues = _e[1];
    var setSortOrder = React.useCallback(function (newSortOrder) {
        rawSetSortOrder(newSortOrder);
        setPageNumber(0);
    }, []);
    var lastInitialSortOrder = usePrevious_1.default(sortingOptions.initialSortOrder);
    React.useEffect(function () {
        if (!shallowEqual_1.default(lastInitialSortOrder, sortingOptions.initialSortOrder)) {
            setSortOrder(sortingOptions.initialSortOrder);
        }
    }, [lastInitialSortOrder, sortingOptions.initialSortOrder]);
    var setAllFilters = React.useCallback(function (filterValues) {
        setFilterValues(filterValues);
        setPageNumber(0);
    }, []);
    var setFilter = React.useCallback(function (filterKey, filterValue) {
        setFilterValues(function (values) {
            var _a;
            return Object.assign({}, values, (_a = {}, _a[filterKey] = filterValue, _a));
        });
        setPageNumber(0);
    }, []);
    var contextValues = {
        paging: {
            pageNumber: pageNumber,
            pageSize: pagingOptions && pagingOptions.pageSize || defaultPageSize,
            setCurrentPage: setPageNumber,
        },
        sorting: {
            sortOrder: sortOrder,
            setSortOrder: setSortOrder
        },
        filtering: {
            setFilter: setFilter,
            setAllFilters: setAllFilters,
            selection: filterValues
        }
    };
    return (React.createElement(exports.ListingContext.Provider, { value: contextValues }, children));
};
exports.default = ListingContextProvider;
//# sourceMappingURL=ListingContext.js.map